import "./App.css";

import { useEffect, useState } from "react";
import { Link, Routes, Route } from "react-router-dom";
import MainTable from "./components/MainTable.js";
import Login from "./pages/Login";
import NewAdmin from "./components/AddAdmin";
import Home from "./pages/Home";
import CategoriesTable from "./components/CategoriesTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchItems, fetchCategories } from "./store/action";
import RequireAuth from "./components/RequireAuth";
import BanLogin from "./components/BanLogin";

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<RequireAuth><Home/></RequireAuth>}>
          <Route path="" element={<MainTable/>} />
          <Route path="categories" element={<CategoriesTable/>} />
          <Route path="new-admin" element={<NewAdmin />} />
        </Route>
        <Route path="/login" element={<BanLogin><Login /></BanLogin>} />
        
      </Routes>
    
    </div>
  );
}

export default App;
